export default __webpack_public_path__ + "static/milesight-f09f5e13a43dbff89d5ddf288edbc5b9.jpg";